import { Colors, Router, Utils, VideoPlayer } from '@lightningjs/sdk';
import Sidebar from './components/widgets/Sidebar/Sidebar';
import routes from './pages/routes';
import lng from '@lightningjs/core';
import SplashScreenComponent from './components/SplashScreen/SplashScreenComponent';
import { getDevice } from './utils/device';
import Dialog from './components/widgets/Dialog/Dialog';
let wasOffline = false; // Variable to track previous internet status
let isDone = false;
let keys = [
  'MediaPlay',
  'MediaPause',
  'MediaStop',
  'ColorF0Red',
  'ColorF1Green',
  'ColorF2Yellow',
  'ColorF3Blue',
  'ChannelUp',
  'ChannelDown',
  '0',
  '1',
  '2',
  '3',
  '4',
  '5',
  '6',
  '7',
  '8',
  '9',
  'MediaRewind',
  'MediaFastForward',
  'MediaRecord',
  'MediaPlayPause',
];
export default class App extends Router.App {
  // static language() {
  //   return 'en';
  // }
  static _template() {
    return {
      Pages: {
        collision: true,
        w: 1920,
        h: 1080,
      },
      // Background
      Background: {
        rect: true,
        w: 1920,
        h: 1080,
        zIndex: -900,
        color: Colors('#000000').get(),
        shader: {},
      },
      Widgets: {
        Sidebar: {
          type: Sidebar,
        },
        Dialog: {
          visible: false,
          type: Dialog,
        },
      },
      // Loader
      Loading: {
        type: SplashScreenComponent,
        rect: true,
        w: 1920,
        h: 1080,
        zIndex: 102,
        color: Colors('#000000').get(),
      },
    };
  }
  // _captureKey(event) {
  //   // Check if the Loading component is visible
  //   const loadingComponent = this.tag('Loading');
  //   const isLoadingVisible = loadingComponent.visible;
  //   if (
  //     (event.keyCode === 8 ||
  //       event.keyCode === 10009 ||
  //       event.keyCode === 461 ||
  //       event.keyCode === 13) &&
  //     isLoadingVisible
  //   ) {
  //     return true;
  //   } else {
  //     return false;
  //   }
  // }
  _captureKey(event) {
    // console.log('_captureKey ', event.keyCode);
    /* if (event.keyCode === 412) {
      event.preventDefault();
      console.log('Here');
      VideoPlayer.skip(-20);
    } */
    // Check if the Loading component is visible
    const loadingComponent = this.tag('Loading');
    const isLoadingVisible = loadingComponent.visible;
    // console.log('current pressed key: ', event.keyCode);
    const exitDialog = this.tag('Dialog');
    const isExitDialogVisible = exitDialog.visible;
    if (event.keyCode === 8 || event.keyCode === 10009) {
      if (isExitDialogVisible) {
        exitDialog.close();
      }
    }
    if (
      (event.keyCode === 8 ||
        event.keyCode === 10009 ||
        event.keyCode === 461 ||
        event.keyCode === 13) &&
      isLoadingVisible
    ) {
      // Prevent the button click
      isDone = true;
      return true;
    } else {
      // Allow the button click
      if (isDone) {
        setTimeout(() => {
          isDone = false;
        }, 1200);
      } else {
        return false;
      }
    }
  }
  _setup() {
    Router.startRouter(routes, this);
    // Check network status initially
    this.checkNetworkStatus();
    // Check network status periodically (e.g., every 5 seconds)
    this.checkInterval = setInterval(() => {
      this.checkNetworkStatus();
    }, 5000); // Adjust the interval as needed
  }
  checkNetworkStatus() {
    const networkDialog = this.tag('Dialog');
    if (navigator.onLine) {
      // The device is online
      // Check if the internet was previously offline
      if (wasOffline) {
        // Internet was offline and is now online
        VideoPlayer.play();
        networkDialog.close();
      }
      // Update the previous internet status
      wasOffline = false;
      // If the dialog is open, close it
    } else {
      // The device is offline
      VideoPlayer.pause();
      networkDialog.open({
        message: 'Problem with Network?',
        actions: [
          {
            label: 'Retry',
            action: () => {
              // dialog.close();
              if (navigator.onLine) {
                networkDialog.close();
                wasOffline = true;
                clearInterval(this.checkInterval);
              } /* else {
                return true;
              } */
            },
          },
          {
            label: 'Exit App',
            action: () => {
              const device = getDevice();
              // Router navigation for "Yes, exit now"
              if (device === 'tizen') {
                window.tizen.application.getCurrentApplication().exit();
              } else if (device === 'web') {
                window.location.href = '';
              } else if (device === 'webos') {
                window.close();
              }
            },
          },
        ],
      });
      // Handle network error globally here
      // Update the previous internet status
      wasOffline = true;
    }
  }
  _handleChannelUp() {
    console.log('ChannelUp ');
  }
  _handleChannelDown() {
    console.log('ChannelDown ');
  }
  _init() {
    console.log('init');
    const device = getDevice();
    if (device === 'tizen') {
      tizen.tvinputdevice.registerKeyBatch(keys);
    }
    // this.tag('Background').shader = {
    //   // x: x + 2,
    //   // y: y + 2,
    //   // w: thumb.w - 4,
    //   // h: thumb.h - 4,
    //   // radius: 20,
    // };
  }
  $punchHole() {
    this.tag('Background').shader = {
      type: lng.shaders.Hole,
      x: 0,
      y: 0,
      w: 1920,
      h: 1080,
    };
  }
  $unpunchHole() {
    this.tag('Background').shader = {
      w: 0,
      h: 0,
    };
  }
  static getFonts() {
    return [
      {
        family: 'OpenSans-Regular',
        url: Utils.asset('fonts/OpenSans-Regular.ttf'),
        descriptors: {},
      },
      {
        family: 'OpenSans-SemiBold',
        url: Utils.asset('fonts/OpenSans-SemiBold.ttf'),
        descriptors: {},
      },
    ];
  }
  _handleAppClose() {
    const dialog = this.tag('Dialog');
    if (dialog.visible) {
      dialog.close();
    } else {
      dialog.open({
        message: 'Are you sure you want to close the app?',
        actions: [
          {
            label: 'No, resume',
            action: () => {
              dialog.close();
            },
          },
          {
            label: 'Yes, exit now',
            action: () => {
              const device = getDevice();
              // Router navigation for "Yes, exit now"
              if (device === 'tizen') {
                window.tizen.application.getCurrentApplication().exit();
              } else if (device === 'web') {
                window.location.href = '';
              } else if (device === 'webos') {
                window.close();
              }
            },
          },
        ],
      });
      dialog.focus();
    }
  }
  /**
   * Show app close dialogue
   * @private
   */
  // _handleAppClose() {
  //   console.log('Close app');
  // }
}
